import { useState, useEffect } from 'react'

export default function useDebounce<T>( value: T, delay = 1000 ) {
	const [ debouncedValue, setDebouncedValue ] = useState<T>( value )

	useEffect(
		() => {
			const handler = setTimeout( () => setDebouncedValue( value ), delay )
			return () => clearTimeout( handler )
		},
		[ value ]
	)

	return debouncedValue
}
